exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.header[data-v-1ddd0305] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/MarketingAds/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;CAC9C","file":"index.vue","sourcesContent":["\n.header[data-v-1ddd0305] {\n  font-weight: 700;\n  font-size: 22px;\n  color: #3F2975;\n  background-color: #fff;\n  display: block;\n  line-height: 22px;\n  padding: 14px 0 14px 64px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ddd0305","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MarketingAds/index.vue
// module id = 1894
// module chunks = 0